import { render, staticRenderFns } from "./ShowThreads.vue?vue&type=template&id=9f23c04c&scoped=true"
import script from "./ShowThreads.vue?vue&type=script&lang=js"
export * from "./ShowThreads.vue?vue&type=script&lang=js"
import style0 from "./ShowThreads.vue?vue&type=style&index=0&id=9f23c04c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f23c04c",
  null
  
)

export default component.exports